<template>
  <div class="users-list-page">
    <TabHeader
      :slideData="tagCategory"
      :tab="tab"
      @headerTabBack="headerTabBack"
    >
      <div class="createBook-btn">
        <button class="global-button-style" @click="createHandle">
          {{ $t("commonMsg.new") }}
        </button>
      </div>
    </TabHeader>
    <transition name="fade-transform" mode="out-in">
      <TagPage :category="tab"></TagPage>
    </transition>

    <el-dialog :visible.sync="isAdd" width="30%" center>
      <div>
        <h4>标题</h4>
        <el-input v-model.trim="createForm.label" clearable></el-input>
        <h4>Key</h4>
        <el-input
          v-model.trim="createForm.key"
          placeholder="(只能输入英文字符)"
          clearable
        ></el-input>
      </div>
      <div slot="footer">
        <el-button @click="isAdd = false">取消</el-button>
        <el-button type="primary" @click="createFeedbackTagCategory"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TabHeader from "@/components/tabHeader";
import TagPage from "./tagPage";
export default {
  components: {
    TabHeader,
    TagPage
  },
  computed: {},
  data() {
    return {
      tab: "funct",
      tagCategory: [],
      isAdd: false,
      createForm: {
        label: "",
        key: ""
      }
    };
  },
  methods: {
    headerTabBack(tab) {
      this.tab = tab.component;
    },

    async getFeedbackTagCategory() {
      let res = await this.$http.getFeedbackTagCategory();
      for (let item of res.data.results) {
        item.component = item.key;
        item.name = item.label;
      }
      this.tagCategory = res.data.results;
    },

    createHandle() {
      this.createForm = {
        label: "",
        key: ""
      };
      this.isAdd = true;
    },

    async createFeedbackTagCategory() {
      await this.$http.createFeedbackTagCategory(this.createForm);
      this.getFeedbackTagCategory();
      this.isAdd = false;
    }
  },
  created() {
    this.getFeedbackTagCategory();
  }
};
</script>

<style lang="scss" scoped>
.users-list-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
